import { render, staticRenderFns } from "./ExpansionListItem.vue?vue&type=template&id=47c9a2a8&scoped=true&"
import script from "./ExpansionListItem.vue?vue&type=script&lang=js&"
export * from "./ExpansionListItem.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionListItem.vue?vue&type=style&index=0&id=47c9a2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c9a2a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VListItem,VMenu})
